"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVEN_CASH_REPORTED_CHECKPOINTS = exports.TERMINAL_TRIGGER_CHECKPOINTS = exports.isAvenCashPartnerReportedCheckpoint = exports.AVEN_CASH_UNREPORTED_STARTED_CHECKPOINTS = exports.STARTED_CHECKPOINT_BY_STEP = exports.STEPPER_VISIBLE_STARTED_CHECKPOINTS = exports.ALL_APPLICATION_STOP_ORDINALS = exports.getApplicationCheckpointOrdinals = exports.AVEN_CASH_APPLICATION_CHECKPOINT_ORDINALS = exports.APPLICATION_CHECKPOINT_ORDINALS = exports.buildApplicationCheckpointOrdinals = exports.isTerminalStatus = exports.TERMINAL_TRIGGERED_BY_STATUS = exports.getApplicationCheckpointCatalog = exports.ApplicationCheckpointCatalogs = exports.APPLICATION_CHECKPOINT_CATALOGS = exports.DEPOSIT_APPLICATION_STEP_TO_CHECKPOINTS = exports.DEPOSIT_APPLICATION_STEP_ORDER = exports.UCC_APPLICATION_STEP_TO_CHECKPOINTS = exports.UCC_APPLICATION_STEP_ORDER = exports.PARALLEL_STEP_GROUPS = exports.STEP_COMPLETION_CHECKPOINT = exports.APPLICATION_STEP_TO_CHECKPOINTS = exports.APPLICATION_STEP_ORDER = exports.TERMINAL_STATUS_ORDER = exports.TerminalStatus = exports.ApplicationStepCheckpoint = exports.ApplicationStep = void 0;
const lodash_1 = require("lodash");
const partnerInquiryProduct_1 = require("./partnerInquiryProduct");
/** Application progress display step IDs. */
/** @TranslateToPython */
var ApplicationStep;
(function (ApplicationStep) {
    ApplicationStep["BROKER_APPLICATION"] = "broker_application";
    ApplicationStep["BORROWER_APPLICATION"] = "borrower_application";
    ApplicationStep["PRE_QUAL_OFFER"] = "pre_qual_offer";
    ApplicationStep["INCOME"] = "income";
    ApplicationStep["INVOLUNTARY_LIEN"] = "involuntary_lien";
    ApplicationStep["APPRAISAL"] = "appraisal";
    ApplicationStep["FINAL_OFFER"] = "final_offer";
    ApplicationStep["BANK_CONNECTION"] = "bank_connection";
    ApplicationStep["TRUST_DOCS"] = "trust_docs";
    ApplicationStep["FLOOD"] = "flood";
    ApplicationStep["NOTARY_BLOCK"] = "notary_block";
    ApplicationStep["NOTARY"] = "notary";
    ApplicationStep["IDENTITY"] = "identity";
    ApplicationStep["RESCISSION"] = "rescission";
    ApplicationStep["WIRE_PAYOFF"] = "wire_payoff";
    ApplicationStep["POST_CLOSE_CONDITIONS"] = "post_close_conditions";
    ApplicationStep["FUNDING"] = "funding";
    ApplicationStep["FUNDED"] = "funded";
    ApplicationStep["DEPOSIT_APPLIED"] = "deposit_applied";
    ApplicationStep["DEPOSIT_UNDER_REVIEW"] = "deposit_under_review";
    ApplicationStep["DEPOSIT_APPROVED"] = "deposit_approved";
})(ApplicationStep || (exports.ApplicationStep = ApplicationStep = {}));
/**
 * Checkpoint IDs.
 *
 * Three flavors, all journaled identically by the cron — only their derivation differs:
 *  - **Per-step `*_STARTED` markers** (one per step): synthesized by `computeApplicationStatus`
 *    from the prior applicable step's last-checkpoint `satisfiedAt` (or `inquiry.createdAt` for
 *    BROKER). Hidden in the stepper UI render (they would duplicate the step header).
 *  - **Within-step natural checkpoints**: fired by underlying domain events, computed by each
 *    step's `checkpointsSatisfaction()`. Rendered in the stepper.
 *  - **Terminal triggered checkpoints** (`*_TRIGGERED`): cron-written when the loan application
 *    transitions to a terminal status. Assigned ordinals above every step ordinal, so MAX(ordinal)
 *    always picks a terminal when present.
 *
 * @TranslateToPython
 */
var ApplicationStepCheckpoint;
(function (ApplicationStepCheckpoint) {
    // Per-step STARTED markers — synthesized at the front of each step's checkpoints list.
    ApplicationStepCheckpoint["BROKER_APPLICATION_STARTED"] = "broker_application_started";
    ApplicationStepCheckpoint["BORROWER_APPLICATION_STARTED"] = "borrower_application_started";
    ApplicationStepCheckpoint["PRE_QUAL_OFFER_STARTED"] = "pre_qual_offer_started";
    ApplicationStepCheckpoint["INCOME_STARTED"] = "income_started";
    ApplicationStepCheckpoint["INVOLUNTARY_LIEN_STARTED"] = "involuntary_lien_started";
    ApplicationStepCheckpoint["APPRAISAL_STARTED"] = "appraisal_started";
    ApplicationStepCheckpoint["FINAL_OFFER_STARTED"] = "final_offer_started";
    ApplicationStepCheckpoint["BANK_CONNECTION_STARTED"] = "bank_connection_started";
    ApplicationStepCheckpoint["TRUST_DOCS_STARTED"] = "trust_docs_started";
    ApplicationStepCheckpoint["FLOOD_STARTED"] = "flood_started";
    ApplicationStepCheckpoint["NOTARY_BLOCK_STARTED"] = "notary_block_started";
    ApplicationStepCheckpoint["NOTARY_STARTED"] = "notary_started";
    ApplicationStepCheckpoint["IDENTITY_STARTED"] = "identity_started";
    ApplicationStepCheckpoint["RESCISSION_STARTED"] = "rescission_started";
    ApplicationStepCheckpoint["WIRE_PAYOFF_STARTED"] = "wire_payoff_started";
    ApplicationStepCheckpoint["POST_CLOSE_CONDITIONS_STARTED"] = "post_close_conditions_started";
    ApplicationStepCheckpoint["FUNDING_STARTED"] = "funding_started";
    ApplicationStepCheckpoint["FUNDED_STARTED"] = "funded_started";
    ApplicationStepCheckpoint["DEPOSIT_APPLIED_STARTED"] = "deposit_applied_started";
    ApplicationStepCheckpoint["DEPOSIT_UNDER_REVIEW_STARTED"] = "deposit_under_review_started";
    ApplicationStepCheckpoint["DEPOSIT_APPROVED_STARTED"] = "deposit_approved_started";
    // Within-step natural checkpoints — fire on underlying domain events; drive the stepper.
    ApplicationStepCheckpoint["BROKER_APPLICATION_SUBMITTED"] = "broker_application_submitted";
    ApplicationStepCheckpoint["BROKER_APPLICATION_SENT"] = "broker_application_sent";
    ApplicationStepCheckpoint["BORROWER_APPLICATION_OPENED"] = "borrower_application_opened";
    ApplicationStepCheckpoint["PRE_QUAL_OFFER_VIEWED"] = "pre_qual_offer_viewed";
    ApplicationStepCheckpoint["PRE_QUAL_OFFER_ACCEPTED"] = "pre_qual_offer_accepted";
    ApplicationStepCheckpoint["INCOME_VERIFIED"] = "income_verified";
    ApplicationStepCheckpoint["INCOME_VERIFIED_OUT_OF_BOUND"] = "income_verified_out_of_bound";
    ApplicationStepCheckpoint["INCOME_OOB_OFFER_SENT"] = "income_oob_offer_sent";
    ApplicationStepCheckpoint["INVOLUNTARY_LIEN_CLEARED"] = "involuntary_lien_cleared";
    ApplicationStepCheckpoint["APPRAISAL_ORDER_PLACED"] = "appraisal_order_placed";
    ApplicationStepCheckpoint["APPRAISAL_SCHEDULED"] = "appraisal_scheduled";
    ApplicationStepCheckpoint["APPRAISAL_COMPLETED"] = "appraisal_completed";
    ApplicationStepCheckpoint["FINAL_OFFER_ACCEPTED"] = "final_offer_accepted";
    ApplicationStepCheckpoint["BANK_CONNECTION_CONNECTED"] = "bank_connection_connected";
    ApplicationStepCheckpoint["TRUST_DOCS_VERIFIED"] = "trust_docs_verified";
    ApplicationStepCheckpoint["FLOOD_VERIFIED"] = "flood_verified";
    ApplicationStepCheckpoint["NOTARY_BLOCK_CLEARED"] = "notary_block_cleared";
    ApplicationStepCheckpoint["NOTARY_SCHEDULED"] = "notary_scheduled";
    ApplicationStepCheckpoint["NOTARY_SIGNED"] = "notary_signed";
    ApplicationStepCheckpoint["IDENTITY_VERIFIED"] = "identity_verified";
    ApplicationStepCheckpoint["RESCISSION_ENDED"] = "rescission_ended";
    ApplicationStepCheckpoint["WIRE_PAYOFF_CLEARED"] = "wire_payoff_cleared";
    ApplicationStepCheckpoint["POST_CLOSE_CONDITIONS_CLEARED"] = "post_close_conditions_cleared";
    ApplicationStepCheckpoint["FUNDING_INITIATED"] = "funding_initiated";
    ApplicationStepCheckpoint["FUNDED"] = "funded";
    ApplicationStepCheckpoint["DEPOSIT_APPLIED_SUBMITTED"] = "deposit_applied_submitted";
    ApplicationStepCheckpoint["DEPOSIT_UNDER_REVIEW_CLEARED"] = "deposit_under_review_cleared";
    ApplicationStepCheckpoint["DEPOSIT_ACCOUNT_OPENED"] = "deposit_account_opened";
    /** @deprecated No longer emitted. `FUNDED` is the terminal-success signal. Kept for legacy journal rows whose value is `'funding_completed'`. */
    ApplicationStepCheckpoint["_FUNDING_COMPLETED"] = "funding_completed";
    // Terminal triggers — cron-written when LA enters a terminal status.
    ApplicationStepCheckpoint["DENIED_TRIGGERED"] = "denied_triggered";
    ApplicationStepCheckpoint["WITHDRAWN_TRIGGERED"] = "withdrawn_triggered";
    ApplicationStepCheckpoint["EXPIRED_TRIGGERED"] = "expired_triggered";
    ApplicationStepCheckpoint["CLOSED_TRIGGERED"] = "closed_triggered";
})(ApplicationStepCheckpoint || (exports.ApplicationStepCheckpoint = ApplicationStepCheckpoint = {}));
/** Terminal statuses — not pipeline steps, but overlay states that halt progress. */
/** @TranslateToPython */
var TerminalStatus;
(function (TerminalStatus) {
    TerminalStatus["DENIED"] = "denied";
    TerminalStatus["WITHDRAWN"] = "withdrawn";
    TerminalStatus["EXPIRED"] = "expired";
    TerminalStatus["CLOSED"] = "closed";
})(TerminalStatus || (exports.TerminalStatus = TerminalStatus = {}));
/** @TranslateToPython */
exports.TERMINAL_STATUS_ORDER = [TerminalStatus.DENIED, TerminalStatus.WITHDRAWN, TerminalStatus.EXPIRED, TerminalStatus.CLOSED];
/** Full ordered list of all possible Aven Cash steps. Not all steps apply to every application. */
/** @TranslateToPython */
exports.APPLICATION_STEP_ORDER = [
    ApplicationStep.BROKER_APPLICATION,
    ApplicationStep.BORROWER_APPLICATION,
    ApplicationStep.PRE_QUAL_OFFER,
    ApplicationStep.INCOME,
    ApplicationStep.INVOLUNTARY_LIEN,
    ApplicationStep.APPRAISAL,
    ApplicationStep.FINAL_OFFER,
    ApplicationStep.BANK_CONNECTION,
    ApplicationStep.TRUST_DOCS,
    ApplicationStep.FLOOD,
    ApplicationStep.NOTARY_BLOCK,
    ApplicationStep.NOTARY,
    ApplicationStep.IDENTITY,
    ApplicationStep.RESCISSION,
    ApplicationStep.WIRE_PAYOFF,
    ApplicationStep.POST_CLOSE_CONDITIONS,
    ApplicationStep.FUNDING,
    ApplicationStep.FUNDED,
];
/**
 * Each step's checkpoint bucket — the canonical order of events within the step. Every step's
 * bucket starts with its `_STARTED` marker; the rest are natural events.
 *
 * Used for:
 *  - Stepper UI rendering (the UI filters `_STARTED` rows so they don't duplicate step headers).
 *  - Ordinal generation (concatenated in `APPLICATION_STEP_ORDER` order).
 *  - `computeApplicationStatus` synthesis-shape invariant: `evaluatedSteps[i].checkpoints` must equal
 *    this bucket for the corresponding step.
 *
 * @TranslateToPython
 */
exports.APPLICATION_STEP_TO_CHECKPOINTS = {
    [ApplicationStep.BROKER_APPLICATION]: [
        ApplicationStepCheckpoint.BROKER_APPLICATION_STARTED,
        ApplicationStepCheckpoint.BROKER_APPLICATION_SUBMITTED,
        ApplicationStepCheckpoint.BROKER_APPLICATION_SENT,
    ],
    [ApplicationStep.BORROWER_APPLICATION]: [ApplicationStepCheckpoint.BORROWER_APPLICATION_STARTED, ApplicationStepCheckpoint.BORROWER_APPLICATION_OPENED],
    [ApplicationStep.PRE_QUAL_OFFER]: [ApplicationStepCheckpoint.PRE_QUAL_OFFER_STARTED, ApplicationStepCheckpoint.PRE_QUAL_OFFER_VIEWED, ApplicationStepCheckpoint.PRE_QUAL_OFFER_ACCEPTED],
    // INCOME_VERIFIED stays last so it remains the step-completion signal; INCOME_VERIFIED_OUT_OF_BOUND
    // is a within-step natural checkpoint that does not gate step progression.
    [ApplicationStep.INCOME]: [
        ApplicationStepCheckpoint.INCOME_STARTED,
        ApplicationStepCheckpoint.INCOME_VERIFIED_OUT_OF_BOUND,
        ApplicationStepCheckpoint.INCOME_OOB_OFFER_SENT,
        ApplicationStepCheckpoint.INCOME_VERIFIED,
    ],
    [ApplicationStep.INVOLUNTARY_LIEN]: [ApplicationStepCheckpoint.INVOLUNTARY_LIEN_STARTED, ApplicationStepCheckpoint.INVOLUNTARY_LIEN_CLEARED],
    [ApplicationStep.APPRAISAL]: [
        ApplicationStepCheckpoint.APPRAISAL_STARTED,
        ApplicationStepCheckpoint.APPRAISAL_ORDER_PLACED,
        ApplicationStepCheckpoint.APPRAISAL_SCHEDULED,
        ApplicationStepCheckpoint.APPRAISAL_COMPLETED,
    ],
    [ApplicationStep.FINAL_OFFER]: [ApplicationStepCheckpoint.FINAL_OFFER_STARTED, ApplicationStepCheckpoint.FINAL_OFFER_ACCEPTED],
    [ApplicationStep.BANK_CONNECTION]: [ApplicationStepCheckpoint.BANK_CONNECTION_STARTED, ApplicationStepCheckpoint.BANK_CONNECTION_CONNECTED],
    [ApplicationStep.TRUST_DOCS]: [ApplicationStepCheckpoint.TRUST_DOCS_STARTED, ApplicationStepCheckpoint.TRUST_DOCS_VERIFIED],
    [ApplicationStep.FLOOD]: [ApplicationStepCheckpoint.FLOOD_STARTED, ApplicationStepCheckpoint.FLOOD_VERIFIED],
    [ApplicationStep.NOTARY_BLOCK]: [ApplicationStepCheckpoint.NOTARY_BLOCK_STARTED, ApplicationStepCheckpoint.NOTARY_BLOCK_CLEARED],
    [ApplicationStep.NOTARY]: [ApplicationStepCheckpoint.NOTARY_STARTED, ApplicationStepCheckpoint.NOTARY_SCHEDULED, ApplicationStepCheckpoint.NOTARY_SIGNED],
    [ApplicationStep.IDENTITY]: [ApplicationStepCheckpoint.IDENTITY_STARTED, ApplicationStepCheckpoint.IDENTITY_VERIFIED],
    [ApplicationStep.RESCISSION]: [ApplicationStepCheckpoint.RESCISSION_STARTED, ApplicationStepCheckpoint.RESCISSION_ENDED],
    [ApplicationStep.WIRE_PAYOFF]: [ApplicationStepCheckpoint.WIRE_PAYOFF_STARTED, ApplicationStepCheckpoint.WIRE_PAYOFF_CLEARED],
    [ApplicationStep.POST_CLOSE_CONDITIONS]: [ApplicationStepCheckpoint.POST_CLOSE_CONDITIONS_STARTED, ApplicationStepCheckpoint.POST_CLOSE_CONDITIONS_CLEARED],
    [ApplicationStep.FUNDING]: [ApplicationStepCheckpoint.FUNDING_STARTED, ApplicationStepCheckpoint.FUNDING_INITIATED],
    [ApplicationStep.FUNDED]: [ApplicationStepCheckpoint.FUNDED_STARTED, ApplicationStepCheckpoint.FUNDED],
};
/**
 * Checkpoint whose presence means a step is complete — the last entry in its bucket. Explicit literal
 * (not Object.fromEntries) so a new step without a completion checkpoint is a compile error; a unit
 * test pins each value to `APPLICATION_STEP_TO_CHECKPOINTS[step].at(-1)`.
 *
 * @TranslateToPython
 */
exports.STEP_COMPLETION_CHECKPOINT = {
    [ApplicationStep.BROKER_APPLICATION]: ApplicationStepCheckpoint.BROKER_APPLICATION_SENT,
    [ApplicationStep.BORROWER_APPLICATION]: ApplicationStepCheckpoint.BORROWER_APPLICATION_OPENED,
    [ApplicationStep.PRE_QUAL_OFFER]: ApplicationStepCheckpoint.PRE_QUAL_OFFER_ACCEPTED,
    [ApplicationStep.INCOME]: ApplicationStepCheckpoint.INCOME_VERIFIED,
    [ApplicationStep.INVOLUNTARY_LIEN]: ApplicationStepCheckpoint.INVOLUNTARY_LIEN_CLEARED,
    [ApplicationStep.APPRAISAL]: ApplicationStepCheckpoint.APPRAISAL_COMPLETED,
    [ApplicationStep.FINAL_OFFER]: ApplicationStepCheckpoint.FINAL_OFFER_ACCEPTED,
    [ApplicationStep.BANK_CONNECTION]: ApplicationStepCheckpoint.BANK_CONNECTION_CONNECTED,
    [ApplicationStep.TRUST_DOCS]: ApplicationStepCheckpoint.TRUST_DOCS_VERIFIED,
    [ApplicationStep.FLOOD]: ApplicationStepCheckpoint.FLOOD_VERIFIED,
    [ApplicationStep.NOTARY_BLOCK]: ApplicationStepCheckpoint.NOTARY_BLOCK_CLEARED,
    [ApplicationStep.NOTARY]: ApplicationStepCheckpoint.NOTARY_SIGNED,
    [ApplicationStep.IDENTITY]: ApplicationStepCheckpoint.IDENTITY_VERIFIED,
    [ApplicationStep.RESCISSION]: ApplicationStepCheckpoint.RESCISSION_ENDED,
    [ApplicationStep.WIRE_PAYOFF]: ApplicationStepCheckpoint.WIRE_PAYOFF_CLEARED,
    [ApplicationStep.POST_CLOSE_CONDITIONS]: ApplicationStepCheckpoint.POST_CLOSE_CONDITIONS_CLEARED,
    [ApplicationStep.FUNDING]: ApplicationStepCheckpoint.FUNDING_INITIATED,
    [ApplicationStep.FUNDED]: ApplicationStepCheckpoint.FUNDED,
};
/**
 * Steps that run concurrently. Members must be contiguous in `APPLICATION_STEP_ORDER` (asserted at
 * backend module load); declaration order is the tie-break for the "current" member when several are pending.
 */
exports.PARALLEL_STEP_GROUPS = [[ApplicationStep.RESCISSION, ApplicationStep.WIRE_PAYOFF, ApplicationStep.POST_CLOSE_CONDITIONS]];
const FIRST_OBSERVATION_CHECKPOINTS = [
    ApplicationStepCheckpoint.POST_CLOSE_CONDITIONS_CLEARED,
    ApplicationStepCheckpoint.NOTARY_BLOCK_CLEARED,
    ApplicationStepCheckpoint.INVOLUNTARY_LIEN_CLEARED,
    ApplicationStepCheckpoint.NOTARY_SIGNED,
    ApplicationStepCheckpoint.FUNDING_INITIATED,
    ApplicationStepCheckpoint.FUNDED,
    ApplicationStepCheckpoint.DENIED_TRIGGERED,
    ApplicationStepCheckpoint.WITHDRAWN_TRIGGERED,
    ApplicationStepCheckpoint.EXPIRED_TRIGGERED,
    ApplicationStepCheckpoint.CLOSED_TRIGGERED,
];
exports.UCC_APPLICATION_STEP_ORDER = [ApplicationStep.PRE_QUAL_OFFER, ApplicationStep.FUNDED];
exports.UCC_APPLICATION_STEP_TO_CHECKPOINTS = {
    [ApplicationStep.PRE_QUAL_OFFER]: [ApplicationStepCheckpoint.PRE_QUAL_OFFER_STARTED, ApplicationStepCheckpoint.PRE_QUAL_OFFER_VIEWED, ApplicationStepCheckpoint.PRE_QUAL_OFFER_ACCEPTED],
    [ApplicationStep.FUNDED]: [ApplicationStepCheckpoint.FUNDED_STARTED, ApplicationStepCheckpoint.FUNDED],
};
const UCC_FIRST_OBSERVATION_CHECKPOINTS = [
    ApplicationStepCheckpoint.PRE_QUAL_OFFER_VIEWED,
    ApplicationStepCheckpoint.FUNDED,
    ApplicationStepCheckpoint.DENIED_TRIGGERED,
    ApplicationStepCheckpoint.WITHDRAWN_TRIGGERED,
    ApplicationStepCheckpoint.EXPIRED_TRIGGERED,
    ApplicationStepCheckpoint.CLOSED_TRIGGERED,
];
/**
 * The Deposit partner journey. Deposit is not a loan or offer flow: progress derives from the
 * CIP/KYC identity verification and the Galileo deposit account status. An opened account is the
 * end of the journey, a first deposit is not tracked.
 */
exports.DEPOSIT_APPLICATION_STEP_ORDER = [ApplicationStep.DEPOSIT_APPLIED, ApplicationStep.DEPOSIT_UNDER_REVIEW, ApplicationStep.DEPOSIT_APPROVED];
exports.DEPOSIT_APPLICATION_STEP_TO_CHECKPOINTS = {
    [ApplicationStep.DEPOSIT_APPLIED]: [ApplicationStepCheckpoint.DEPOSIT_APPLIED_STARTED, ApplicationStepCheckpoint.DEPOSIT_APPLIED_SUBMITTED],
    [ApplicationStep.DEPOSIT_UNDER_REVIEW]: [ApplicationStepCheckpoint.DEPOSIT_UNDER_REVIEW_STARTED, ApplicationStepCheckpoint.DEPOSIT_UNDER_REVIEW_CLEARED],
    [ApplicationStep.DEPOSIT_APPROVED]: [ApplicationStepCheckpoint.DEPOSIT_APPROVED_STARTED, ApplicationStepCheckpoint.DEPOSIT_ACCOUNT_OPENED],
};
const DEPOSIT_FIRST_OBSERVATION_CHECKPOINTS = [
    ApplicationStepCheckpoint.DEPOSIT_UNDER_REVIEW_CLEARED,
    ApplicationStepCheckpoint.DEPOSIT_ACCOUNT_OPENED,
    ApplicationStepCheckpoint.DENIED_TRIGGERED,
    ApplicationStepCheckpoint.WITHDRAWN_TRIGGERED,
    ApplicationStepCheckpoint.EXPIRED_TRIGGERED,
    ApplicationStepCheckpoint.CLOSED_TRIGGERED,
];
exports.APPLICATION_CHECKPOINT_CATALOGS = {
    [partnerInquiryProduct_1.PartnerInquiryProduct.AVEN_CASH]: {
        stepOrder: exports.APPLICATION_STEP_ORDER,
        checkpointsByStep: exports.APPLICATION_STEP_TO_CHECKPOINTS,
        defaultStep: ApplicationStep.BROKER_APPLICATION,
        terminalSuccessCheckpoint: ApplicationStepCheckpoint.FUNDED,
        parallelStepGroups: exports.PARALLEL_STEP_GROUPS,
        optionalParallelSteps: [ApplicationStep.WIRE_PAYOFF],
        firstCheckpointOrdinal: 1,
        terminalStatusOrdinalStart: 1000,
        additionalStopCheckpoints: [ApplicationStepCheckpoint._FUNDING_COMPLETED],
        fixedCheckpointOrdinals: { [ApplicationStepCheckpoint._FUNDING_COMPLETED]: { ordinal: 999, step: ApplicationStep.FUNDED } },
        firstObservationCheckpoints: FIRST_OBSERVATION_CHECKPOINTS,
    },
    [partnerInquiryProduct_1.PartnerInquiryProduct.AVEN_UCC]: {
        stepOrder: exports.UCC_APPLICATION_STEP_ORDER,
        checkpointsByStep: exports.UCC_APPLICATION_STEP_TO_CHECKPOINTS,
        defaultStep: ApplicationStep.PRE_QUAL_OFFER,
        terminalSuccessCheckpoint: ApplicationStepCheckpoint.FUNDED,
        parallelStepGroups: [],
        optionalParallelSteps: [],
        firstCheckpointOrdinal: 2000,
        terminalStatusOrdinalStart: 2500,
        additionalStopCheckpoints: [],
        fixedCheckpointOrdinals: {},
        firstObservationCheckpoints: UCC_FIRST_OBSERVATION_CHECKPOINTS,
    },
    [partnerInquiryProduct_1.PartnerInquiryProduct.AVEN_DEPOSIT]: {
        stepOrder: exports.DEPOSIT_APPLICATION_STEP_ORDER,
        checkpointsByStep: exports.DEPOSIT_APPLICATION_STEP_TO_CHECKPOINTS,
        defaultStep: ApplicationStep.DEPOSIT_APPLIED,
        terminalSuccessCheckpoint: ApplicationStepCheckpoint.DEPOSIT_ACCOUNT_OPENED,
        parallelStepGroups: [],
        optionalParallelSteps: [],
        firstCheckpointOrdinal: 3000,
        terminalStatusOrdinalStart: 3500,
        additionalStopCheckpoints: [],
        fixedCheckpointOrdinals: {},
        firstObservationCheckpoints: DEPOSIT_FIRST_OBSERVATION_CHECKPOINTS,
    },
};
/** Shared product identity for catalog selectors and backend SQL grouping; never changes the stored product. */
exports.ApplicationCheckpointCatalogs = {
    /** Purchase temporarily uses Cash milestones; its dedicated checkpoint catalog is coming in the next PRs. */
    productFor: ({ product }) => {
        return product === partnerInquiryProduct_1.PartnerInquiryProduct.AVEN_HOME_PURCHASE ? partnerInquiryProduct_1.PartnerInquiryProduct.AVEN_CASH : product;
    },
};
/**
 * The stored inquiry product owns its journey, independently of the linked loan's asset type.
 * Purchase deliberately shares the existing Cash journey until its separate milestones are introduced.
 */
const getApplicationCheckpointCatalog = ({ product }) => {
    return exports.APPLICATION_CHECKPOINT_CATALOGS[exports.ApplicationCheckpointCatalogs.productFor({ product })];
};
exports.getApplicationCheckpointCatalog = getApplicationCheckpointCatalog;
/** Maps each terminal status to the journal checkpoint emitted when it is first observed. */
exports.TERMINAL_TRIGGERED_BY_STATUS = {
    [TerminalStatus.DENIED]: ApplicationStepCheckpoint.DENIED_TRIGGERED,
    [TerminalStatus.WITHDRAWN]: ApplicationStepCheckpoint.WITHDRAWN_TRIGGERED,
    [TerminalStatus.EXPIRED]: ApplicationStepCheckpoint.EXPIRED_TRIGGERED,
    [TerminalStatus.CLOSED]: ApplicationStepCheckpoint.CLOSED_TRIGGERED,
};
const isTerminalStatus = (value) => exports.TERMINAL_STATUS_ORDER.includes(value);
exports.isTerminalStatus = isTerminalStatus;
const buildApplicationCheckpointOrdinals = (catalog) => {
    const checkpoint = {};
    const step = {};
    let ordinal = catalog.firstCheckpointOrdinal;
    // Walk the journey step by step, numbering each milestone in the order the applicant reaches it.
    for (const applicationStep of catalog.stepOrder) {
        const stepCheckpoints = catalog.checkpointsByStep[applicationStep];
        if (!stepCheckpoints || stepCheckpoints.length === 0) {
            throw new Error(`Application checkpoint catalog has no checkpoints for ${applicationStep}`);
        }
        step[applicationStep] = stepCheckpoints.map((applicationCheckpoint) => {
            checkpoint[applicationCheckpoint] = ordinal;
            return ordinal++;
        });
    }
    // A terminal outcome must outrank every milestone on the path, or a denied applicant could still look like they are moving.
    if (catalog.terminalStatusOrdinalStart <= ordinal - 1) {
        throw new Error(`Terminal status ordinals must follow every pipeline checkpoint; received ${catalog.terminalStatusOrdinalStart} after ${ordinal - 1}`);
    }
    // Milestones from an older layout keep their historical number, filed under the step that owns them today.
    for (const [applicationCheckpoint, fixedCheckpointOrdinal] of Object.entries(catalog.fixedCheckpointOrdinals)) {
        const owningStepOrdinals = step[fixedCheckpointOrdinal.step];
        if (!owningStepOrdinals) {
            throw new Error(`Fixed ordinal for ${applicationCheckpoint} belongs to ${fixedCheckpointOrdinal.step}, which is not in the catalog step order`);
        }
        if (fixedCheckpointOrdinal.ordinal >= catalog.terminalStatusOrdinalStart) {
            throw new Error(`Fixed ordinal ${fixedCheckpointOrdinal.ordinal} for ${applicationCheckpoint} must precede the terminal status ordinals starting at ${catalog.terminalStatusOrdinalStart}`);
        }
        if (Object.values(checkpoint).includes(fixedCheckpointOrdinal.ordinal)) {
            throw new Error(`Fixed ordinal ${fixedCheckpointOrdinal.ordinal} for ${applicationCheckpoint} collides with another checkpoint in the catalog`);
        }
        checkpoint[applicationCheckpoint] = fixedCheckpointOrdinal.ordinal;
        step[fixedCheckpointOrdinal.step] = [...owningStepOrdinals, fixedCheckpointOrdinal.ordinal];
    }
    // The ways the story can end (denied, withdrawn, expired, closed) get a band of their own past the last step.
    const terminal = {
        [TerminalStatus.DENIED]: [],
        [TerminalStatus.WITHDRAWN]: [],
        [TerminalStatus.EXPIRED]: [],
        [TerminalStatus.CLOSED]: [],
    };
    for (const [index, terminalStatus] of exports.TERMINAL_STATUS_ORDER.entries()) {
        const applicationCheckpoint = exports.TERMINAL_TRIGGERED_BY_STATUS[terminalStatus];
        const terminalOrdinal = catalog.terminalStatusOrdinalStart + index;
        checkpoint[applicationCheckpoint] = terminalOrdinal;
        terminal[terminalStatus] = [terminalOrdinal];
    }
    // Reverse lookup, so the highest ordinal in a journal answers "which step or outcome is this applicant at".
    const statusByOrdinal = new Map();
    for (const applicationStep of catalog.stepOrder) {
        for (const stepOrdinal of step[applicationStep] ?? []) {
            statusByOrdinal.set(stepOrdinal, applicationStep);
        }
    }
    for (const terminalStatus of exports.TERMINAL_STATUS_ORDER) {
        for (const terminalOrdinal of terminal[terminalStatus]) {
            statusByOrdinal.set(terminalOrdinal, terminalStatus);
        }
    }
    // Milestones after which nothing more happens: funded, any terminal outcome, and whatever the product adds.
    const stopCheckpoints = [catalog.terminalSuccessCheckpoint, ...catalog.additionalStopCheckpoints, ...Object.values(exports.TERMINAL_TRIGGERED_BY_STATUS)];
    const stop = stopCheckpoints.flatMap((applicationCheckpoint) => {
        const applicationCheckpointOrdinal = checkpoint[applicationCheckpoint];
        return applicationCheckpointOrdinal === undefined ? [] : [applicationCheckpointOrdinal];
    });
    return { checkpoint, step, terminal, statusByOrdinal, stop };
};
exports.buildApplicationCheckpointOrdinals = buildApplicationCheckpointOrdinals;
/** Every distinct journey has ordinals; Purchase explicitly shares the Cash journey. */
exports.APPLICATION_CHECKPOINT_ORDINALS = (0, lodash_1.mapValues)(exports.APPLICATION_CHECKPOINT_CATALOGS, (catalog) => (0, exports.buildApplicationCheckpointOrdinals)(catalog));
/** Aven Cash partner progress, independent of the linked loan's Aven product line. */
exports.AVEN_CASH_APPLICATION_CHECKPOINT_ORDINALS = exports.APPLICATION_CHECKPOINT_ORDINALS[partnerInquiryProduct_1.PartnerInquiryProduct.AVEN_CASH];
/** Returns cached ordinals by stored inquiry product, using the same catalog normalization as catalog selection and SQL. */
const getApplicationCheckpointOrdinals = ({ product }) => {
    return exports.APPLICATION_CHECKPOINT_ORDINALS[exports.ApplicationCheckpointCatalogs.productFor({ product })];
};
exports.getApplicationCheckpointOrdinals = getApplicationCheckpointOrdinals;
const assertApplicationCheckpointOrdinalRangesDoNotOverlap = () => {
    const ordinalValues = Object.values(exports.APPLICATION_CHECKPOINT_ORDINALS).flatMap((ordinals) => Object.values(ordinals.checkpoint).filter((ordinal) => ordinal !== undefined));
    if (new Set(ordinalValues).size !== ordinalValues.length) {
        throw new Error('Application checkpoint catalog ordinal ranges overlap');
    }
};
assertApplicationCheckpointOrdinalRangesDoNotOverlap();
exports.ALL_APPLICATION_STOP_ORDINALS = [...new Set(Object.values(exports.APPLICATION_CHECKPOINT_ORDINALS).flatMap((ordinals) => ordinals.stop))];
/**
 * `_STARTED` markers the dashboard stepper renders; every other `_STARTED` marker is hidden (it
 * would duplicate the step header). Shared source of truth for the stepper `displayInStepper`
 * decision on `_STARTED` markers and for the dashboard-variant inquiry-report CSV column set.
 * @TranslateToPython
 */
exports.STEPPER_VISIBLE_STARTED_CHECKPOINTS = [ApplicationStepCheckpoint.RESCISSION_STARTED];
/** Maps each step to its `_STARTED` checkpoint (= the first entry in its bucket). */
exports.STARTED_CHECKPOINT_BY_STEP = (0, lodash_1.mapValues)(exports.APPLICATION_STEP_TO_CHECKPOINTS, (checkpoints) => checkpoints[0]);
const STEPPER_VISIBLE_STARTED_CHECKPOINT_SET = new Set(exports.STEPPER_VISIBLE_STARTED_CHECKPOINTS);
/** `_STARTED` markers no Aven Cash partner-facing surface reports. */
exports.AVEN_CASH_UNREPORTED_STARTED_CHECKPOINTS = new Set(Object.values(exports.STARTED_CHECKPOINT_BY_STEP).filter((checkpoint) => !STEPPER_VISIBLE_STARTED_CHECKPOINT_SET.has(checkpoint)));
const isAvenCashPartnerReportedCheckpoint = (checkpoint) => !exports.AVEN_CASH_UNREPORTED_STARTED_CHECKPOINTS.has(checkpoint);
exports.isAvenCashPartnerReportedCheckpoint = isAvenCashPartnerReportedCheckpoint;
/** @TranslateToPython */
exports.TERMINAL_TRIGGER_CHECKPOINTS = [
    ApplicationStepCheckpoint.DENIED_TRIGGERED,
    ApplicationStepCheckpoint.WITHDRAWN_TRIGGERED,
    ApplicationStepCheckpoint.EXPIRED_TRIGGERED,
    ApplicationStepCheckpoint.CLOSED_TRIGGERED,
];
/** Aven Cash webhook/API vocabulary, in reporting order. */
exports.AVEN_CASH_REPORTED_CHECKPOINTS = [
    ...exports.APPLICATION_STEP_ORDER.flatMap((applicationStep) => exports.APPLICATION_STEP_TO_CHECKPOINTS[applicationStep]),
    ...exports.TERMINAL_TRIGGER_CHECKPOINTS,
].filter(exports.isAvenCashPartnerReportedCheckpoint);
